import React from 'react'
import { WidgetContent, Divider, TextField, Select, DropdownMenuPosition } from '@duik/it'
import CreateNewModal from '../UI/CreateNewModal'
import FormInputGroup from '../UI/FormInputGroup'
import { Formik, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { ModalButton } from '../UI/ModalButton'
import { EditProjectProps, ProjectInput } from './Types/types'

const EditProject: React.FC<EditProjectProps> = ({
  editProject,
  editProjectDetail,
  editProjectModalToggle
}) => {
  const handleEditProject = (values: ProjectInput) => {
    const { _id } = editProjectDetail
    editProject(_id, values)
    editProjectModalToggle()
  }

  return (
    <CreateNewModal title="Edit Project" handleCloseModal={editProjectModalToggle}>
      <Formik
        initialValues={{
          projectName: editProjectDetail.projectName,
          projectNumber: editProjectDetail.projectNumber,
          officeAddress: editProjectDetail.officeAddress,
          city: editProjectDetail.city,
          province: editProjectDetail.province
        }}
        validationSchema={ProjectSchema}
        onSubmit={values => {
          handleEditProject(values)
        }}
        render={({
          values,
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit}>
            <WidgetContent>
              <FormInputGroup>
                <FormInputGroup direction="horizontal">
                  <div>
                    <TextField
                      className="fullWidthInputBox"
                      label="Project Name"
                      name="projectName"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.projectName}
                    />
                    <ErrorMessage
                      name="projectName"
                      render={msg => (
                        <span
                          style={{
                            position: 'absolute',
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                </FormInputGroup>
                <FormInputGroup direction="horizontal">
                  <div style={{ marginTop: '16px' }}>
                    <TextField
                      className="fullWidthInputBox"
                      label="Project Number"
                      name="projectNumber"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.projectNumber}
                    />
                    <ErrorMessage
                      name="projectNumber"
                      render={msg => (
                        <span
                          style={{
                            position: 'absolute',
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                </FormInputGroup>
              </FormInputGroup>
            </WidgetContent>
            <Divider />
            <WidgetContent style={{ backgroundColor: '#FBFBFD' }}>
              <FormInputGroup>
                <FormInputGroup>
                  <FormInputGroup direction="horizontal">
                    <div style={{ marginBottom: '20px', marginTop: '10px' }}>
                      <TextField
                        className="fullWidthInputBox"
                        label="Office Address"
                        name="officeAddress"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.officeAddress}
                      />
                      <ErrorMessage
                        name="officeAddress"
                        render={msg => (
                          <span
                            style={{
                              position: 'absolute',
                              color: '#E6492D',
                              fontSize: '0.75rem'
                            }}
                          >
                            {msg}
                          </span>
                        )}
                      />
                    </div>
                  </FormInputGroup>
                </FormInputGroup>
                <FormInputGroup direction="horizontal">
                  <div style={{ marginRight: '10px' }}>
                    <TextField
                      className="halfWidthInputBox"
                      label="City"
                      name="city"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.city}
                    />
                    <ErrorMessage
                      name="city"
                      render={msg => (
                        <span
                          style={{
                            position: 'absolute',
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                  <div className="halfWidthInputBoxSelectHaul">
                    <Select
                      className="projecProvinceSelect"
                      style={{ padding: 0, boxShadow: 'none', width: '100%' }}
                      activeOption={{
                        value: values.province,
                        label: values.province
                      }}
                      label="STATE"
                      name="province"
                      options={[
                        { value: 'LA', label: 'LA' },
                        { value: 'MS', label: 'MS' },
                        { value: 'TX', label: 'TX' },
                        { value: 'AL', label: 'AL' },
                        { value: 'FL', label: 'FL' }
                      ]}
                      menuPosition={DropdownMenuPosition['bottom-right']}
                      onOptionClick={e => {
                        setFieldValue('province', e.value)
                      }}
                    />
                    <ErrorMessage
                      name="province"
                      render={msg => (
                        <span
                          style={{
                            position: 'absolute',
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                </FormInputGroup>
              </FormInputGroup>
            </WidgetContent>
            <WidgetContent style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ width: '83px' }}>
                <ModalButton
                  buttonStyle="tertiary"
                  name="Cancel"
                  onClick={editProjectModalToggle}
                />
              </div>
              <div style={{ width: '83px' }}>
                <ModalButton success type="submit" disabled={isSubmitting} name="Save" />
              </div>
            </WidgetContent>
          </form>
        )}
      />
    </CreateNewModal>
  )
}

export default EditProject

const ProjectSchema = Yup.object().shape({
  projectName: Yup.string()
    .min(2, 'Too Short!')
    .max(30, 'Too Long!')
    .required('Required'),
  projectNumber: Yup.string()
    .min(2, 'Too Short!')
    .max(30, 'Too Long!')
    .required('Required'),
  officeAddress: Yup.string()
    .min(1, 'Too Short!')
    .max(30, 'Too Long!')
    .required('Required'),
  city: Yup.string()
    .min(2, 'Too Short!')
    .max(30, 'Too Long!')
    .required('Required'),
  province: Yup.string().required('Required')
})
